import {AfterViewInit, Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {ChartDataInterface} from "./chart-data.interface";
import {Router} from "@angular/router";
import {Image} from "@amcharts/amcharts4/core";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, AfterViewInit, OnDestroy {
  private aroundTheWorld = require('./data/around-the-world.json');
  private torchNameMeme = require('./data/torch-name.json');
  private flashlight = require('./data/flashlight.json');

  private chartData: ChartDataInterface;
  private currentChart: any;

  private readonly availableCharts: [ChartDataInterface];

  chartTitle: string;
  chartType: string;

  constructor(private zone: NgZone, private router: Router) {
    this.availableCharts = [this.torchNameMeme, this.aroundTheWorld, this.flashlight] as unknown as [ChartDataInterface];
  }

  ngOnInit(): void {
    // this.chartData = this.availableCharts[Math.floor(Math.random() * this.availableCharts.length)];
    this.chartData = this.flashlight;
    this.chartTitle = this.chartData.name;
    this.chartType = this.chartData.type;
  }

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      let chart;

      if (this.chartData.type == "pie") {
        chart = am4core.create("mainChart", am4charts.PieChart);
        chart.data = this.chartData.data as any[];
        const pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";

        pieSeries.innerRadius = am4core.percent(50);
        pieSeries.ticks.template.disabled = true;
        pieSeries.labels.template.disabled = true;
        pieSeries.tooltip.disabled = true;
      } else if (this.chartData.type == "image") {
        chart = am4core.create("mainChart", am4charts.XYChart);

        let chartImage = chart.plotContainer.createChild(Image)
        chartImage.href = this.chartData.data as string;
        chartImage.width = am4core.percent(100);
        chartImage.height = am4core.percent(100);
        chartImage.nonScaling = true;
      } else if (this.chartData.type == "gif") {
        let image = document.createElement('img');
        image.src = this.chartData.data as string;
        image.className = "gif-not-found"

        document.getElementById('mainChart').appendChild(image)
      }

      if (chart instanceof am4charts.Chart) {
        if (this.chartData.showLegend) {
          chart.legend = new am4charts.Legend();
          chart.legend.position = "right";
        }

        chart.logo.disabled = true;
      }

      this.currentChart = chart;
    });
  }

  goToDashboard() {
    this.router.navigate(['/pages/applications/dashboard']).then();
  }

  ngOnDestroy() {
    if (!!this.currentChart && this.currentChart instanceof am4charts.Chart) {
      this.currentChart.dispose();
    }
  }
}
